module.exports = __webpack_public_path__ + "static/media/bro.ec9daf4f.png";